export const base_url = 'http://gurdwarabvs.org:5000';